import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideRouter } from '@angular/router';
import { initializeApp } from '@core/app.initializer';
import { authRequestInterceptor } from '@core/interceptors/request.interceptor';
import { LanguageService } from '@core/services/language/language.service';
import { provideLoadingBarInterceptor } from '@ngx-loading-bar/http-client';
import { TranslateLoader, TranslateModule, TranslateStore } from '@ngx-translate/core';
import { CustomTranslateLoader, translateInitializerFactory } from '@shared/utils/translate-loader.util';
import { FONT_PICKER_CONFIG } from 'ngx-font-picker';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app.routes';

registerLocaleData(localeDe);
registerLocaleData(localeFr);

export const AppConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    importProvidersFrom(
      ToastrModule.forRoot({
        closeButton: true,
        timeOut: 3000,
        autoDismiss: true,
        preventDuplicates: true,
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: () => new CustomTranslateLoader(),
        },
      }),
      MatSnackBarModule,
    ),
    provideLoadingBarInterceptor(),
    provideAppInitializer(() => translateInitializerFactory(inject(LanguageService))),
    DatePipe,
    TranslateStore,
    provideAppInitializer(initializeApp),
    { provide: FONT_PICKER_CONFIG, useValue: { apiKey: 'AIzaSyBqtmUTutNQFOA2YDCU_UyO1QqvNtLOyx0' } },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } },
    {
      provide: LOCALE_ID,
      useFactory: () => LanguageService.getLocale(),
    },
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([authRequestInterceptor])),
  ],
};
